import type {Result, UseCase} from 'framework';
import type {ScheduleError} from '../../domain/errors';
import type {ScheduleWeekSlot} from '../../domain/schedule-week-slot';
import type {ScheduleRepository} from '../ports/schedule.repository';

export class GetScheduleWeek implements UseCase<[], readonly ScheduleWeekSlot[]> {
  constructor(private readonly repository: ScheduleRepository) {}

  execute(): Promise<Result<readonly ScheduleWeekSlot[], ScheduleError>> {
    return this.repository.getWeek();
  }
}
